/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeDeliveryNoteBundle } from '../../models/consignee-delivery-note-bundle';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeBundle$Params {
  organizationSiteKey: KeyType;
  deliveryNoteBundleKey: KeyType;
}

export function getConsigneeBundle(http: HttpClient, rootUrl: string, params: GetConsigneeBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNoteBundle>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeBundle.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeDeliveryNoteBundle>;
    })
  );
}

getConsigneeBundle.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-note-bundles/{deliveryNoteBundleKey}';
